var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "ruleForm6",
          staticClass: "demo-ruleForm",
          staticStyle: { width: "60%", "margin-top": "20px" },
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "150px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "appId", prop: "appId" } },
            [
              _c("el-input", {
                attrs: { placeholder: "" },
                model: {
                  value: _vm.ruleForm.appId,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "appId", $$v)
                  },
                  expression: "ruleForm.appId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "appKey", prop: "appKey" } },
            [
              _c("el-input", {
                attrs: { placeholder: "" },
                model: {
                  value: _vm.ruleForm.appKey,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "appKey", $$v)
                  },
                  expression: "ruleForm.appKey",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "appSecret", prop: "appSecret" } },
            [
              _c("el-input", {
                attrs: { placeholder: "" },
                model: {
                  value: _vm.ruleForm.appSecret,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "appSecret", $$v)
                  },
                  expression: "ruleForm.appSecret",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "channelId" } },
            [
              _c("el-input", {
                attrs: { placeholder: "" },
                model: {
                  value: _vm.ruleForm.channelId,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "channelId", $$v)
                  },
                  expression: "ruleForm.channelId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticStyle: { "margin-top": "20px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("ruleForm6")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }